// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__39kid","boxTitle":"Qualiphy_boxTitle__2lE9e","box":"Qualiphy_box__2zHKC","toggleWrap":"Qualiphy_toggleWrap__3P3W_"};